import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "react-fa";
import Button from "components/Button";
import GoogleMapContainer from "./GoogleMap";

const ContactInfo = () => (
  <div className="section container">
    <div className="columns">
      <div className="column is-5">
        <h3 className="title is-3">Questions? Comments? Concerns?</h3>
        <p>
          We'd love to hear from you, and would be happy to answer any questions
          you may have about the types of projects we take on, our capabilities
          as a machine shop, estimates on projects, and of course, any concerns
          you may have at all. Feel free to give us a call at the number below,
          or simply
          <Link to="/contact"> leave us a message </Link>
          on our website.
        </p>
        <br />
        <h4 className="title is-3">Contact Info</h4>
        <ul>
          <li>tel: +1 818 843 1500</li>
          <li>fax: +1 818 841 2117</li>
          <li>
            2211 Kenmere Avenue <br /> Burbank, California 91504
          </li>
          <li>Business Development:&nbsp;<a href="mailto:businessdevelopment@accratronics.com">businessdevelopment@accratronics.com</a></li>
          <li>Request for Quotes:&nbsp;<a href="mailto:quotes@accratronics.com">quotes@accratronics.com</a></li>
        </ul>
      </div>
      <div className="column is-offset-1">
        <h5 className="title is-4">Find Us On The Map</h5>
        <GoogleMapContainer />
        <div className="content" style={{ marginTop: "1rem" }}>
          <a
            href="https://www.google.com/maps/dir/Current+Location/2211+Kenmere+Avenue+Burbank+CA+91504"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="brand" isOutlined>
              <Icon name="car" />
              <span style={{ marginLeft: "1rem" }}>Get Driving Directions</span>
            </Button>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/pages/About/components/ContactInfo.js